import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSave = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.00001 5.40001C5.67001 5.40001 5.40001 5.67001 5.40001 6.00001V18C5.40001 18.33 5.67001 18.6 6.00001 18.6H18C18.33 18.6 18.6 18.33 18.6 18V8.89876C18.6 8.74126 18.5363 8.58751 18.4238 8.47501L15.6 5.64751V9.00001C15.6 9.66376 15.0638 10.2 14.4 10.2H8.40001C7.73626 10.2 7.20001 9.66376 7.20001 9.00001V5.40001H6.00001ZM9.00001 5.40001V8.40001H13.8V5.40001H9.00001ZM3.60001 6.00001C3.60001 4.67626 4.67626 3.60001 6.00001 3.60001H15.1013C15.7388 3.60001 16.35 3.85126 16.8 4.30126L19.6988 7.20001C20.1488 7.65001 20.4 8.26126 20.4 8.89876V18C20.4 19.3238 19.3238 20.4 18 20.4H6.00001C4.67626 20.4 3.60001 19.3238 3.60001 18V6.00001ZM9.60001 14.4C9.60001 13.0763 10.6763 12 12 12C13.3238 12 14.4 13.0763 14.4 14.4C14.4 15.7238 13.3238 16.8 12 16.8C10.6763 16.8 9.60001 15.7238 9.60001 14.4Z",
		fill: "currentColor"
	})
});
export default SvgSave;
